"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var vee_validate_1 = require("vee-validate");
var rules_1 = require("vee-validate/dist/rules");
var libphonenumber_js_1 = require("libphonenumber-js");
var AppBand_1 = require("../../components/globals/AppBand");
var axios_1 = require("axios");
vee_validate_1.extend('required', rules_1.required);
vee_validate_1.extend('email', rules_1.email);
vee_validate_1.extend('tel', {
    validate: function (value) {
        var phoneNumber = libphonenumber_js_1.parsePhoneNumberFromString(value, 'JP');
        if (!phoneNumber) {
            return false;
        }
        return phoneNumber.isValid();
    }
});
vue_property_decorator_1.Vue.component('ValidationProvider', vee_validate_1.ValidationProvider);
vue_property_decorator_1.Vue.component('ValidationObserver', vee_validate_1.ValidationObserver);
var Form = /** @class */ (function (_super) {
    __extends(Form, _super);
    function Form() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.width = "440px";
        _this.form = {
            companyName: '',
            officeName: '',
            serviceType: '',
            address: '',
            tel: '',
            name: '',
            email: '',
            jobType: []
        };
        _this.hasError = false;
        return _this;
    }
    Form.prototype.beforeCreate = function () {
        document.title = "申込 | 自宅でできる介護リハビリ - リハプラン";
        document.querySelector("meta[property='og:title']").setAttribute('content', "申込 | 自宅でできる介護リハビリ - リハプラン");
        document.querySelector("meta[name='description']").setAttribute('content', "リハプランの特設サイト「自宅でできる介護リハビリ」の申込みはこちらです。下記のフォームへの必要事項をご記入いただき、送信ボタンをクリックしてください。");
        document.querySelector("meta[property='og:description']").setAttribute('content', "リハプランの特設サイト「自宅でできる介護リハビリ」の申込みはこちらです。下記のフォームへの必要事項をご記入いただき、送信ボタンをクリックしてください。");
        document.querySelector("meta[name='keywords']").setAttribute('content', "自宅でできる,介護リハビリ,申込み,リハプラン");
        document.querySelector("link[rel='canonical']").setAttribute('href', "https://rehaplan.jp/keeprehab/form");
    };
    Form.prototype.refs = function () {
        return this.$refs;
    };
    Form.prototype.mounted = function () {
        this.$vuetify.goTo(0, {
            duration: 1,
            offset: 0,
            easing: 'easeInOutCubic'
        });
        this.$ga.event({
            eventCategory: '【STOP_COVID_19】フォームに遷移',
            eventAction: '【STOP_COVID_19】フォームに遷移',
            eventLabel: '【STOP_COVID_19】フォームに遷移'
        });
    };
    Form.prototype.getConditionalRule = function (rule) {
        if (this.form.serviceType === this.$t('view.form.values.other')) {
            return '';
        }
        return rule;
    };
    Form.prototype.getErrorMessage = function (errorLength, columnName) {
        if (errorLength === 0) {
            return '';
        }
        return this.$t("view.form.errorMessage." + columnName);
    };
    Form.prototype.submitUserForm = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var self_, _a, url_, params;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        event.preventDefault();
                        self_ = this;
                        _a = this;
                        return [4 /*yield*/, this.refs().inputObserver.validate()];
                    case 1:
                        _a.hasError = !(_b.sent());
                        if (this.hasError) {
                            this.$vuetify.goTo('#error-panel');
                            return [2 /*return*/];
                        }
                        url_ = self_.$invokeUrlMaker.create('form');
                        params = JSON.stringify(self_.form);
                        axios_1.default.post(url_, params).then(function (res) {
                            if (res['data']) {
                                window['order_id'] = res['data']['orderId'];
                            }
                            self_.$router.push({ path: '/keeprehab/login' });
                        }).catch(function (err) {
                            console.log(err);
                            alert('エラーが発生しました。');
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    Form = __decorate([
        vue_property_decorator_1.Component({
            components: {
                ValidationProvider: vee_validate_1.ValidationProvider,
                ValidationObserver: vee_validate_1.ValidationObserver,
                AppBand: AppBand_1.default
            }
        })
    ], Form);
    return Form;
}(vue_property_decorator_1.Vue));
exports.default = Form;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/form/Form.vue
// module id = 01mu
// module chunks = 1